// src/components/Pages/LmsPanel.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import './../../style/Vars.css';
import './../../style/MobileStyles.css';

// 🔹 Endpoints y modelos de Seguridad
import { ENDPOINTS } from "../Seguridad/Utils/Endpoints";
import { Models } from "../Seguridad/Utils/ModelsSeguridad";

// 🔹 Usuario en sesión
import { getSessionUserId } from "../../utils/SessionUser";

// Íconos para cada submódulo
const submoduleIcons = {
    estudiantes: '👨‍🎓',
    estadisticas: '📊',
    cursos: '📚',
    misCursos: '🎓',
    catalogoCursos: '📚',
    catalogoCarreras: '🎓',
    misCarreras: '🏁',
    misCertificados: '🏆',
    tiendaPremios: '🎁',
    progreso: '📈',
    dashboardGeneral: '📊',
    asignarCursosEstudiantes: '📝',
    asignarCursosArea: '🏢',
    asignarCursosPuesto: '💼',
    asignarCursosTurno: '🕒',
    carreras: '🏁',
    semestres: '📅',
    asignacionMasivaUO: '🏢',
    asignacionMasivaEmpresa: '💼',
    fechasLimiteUO: '🏢',
    fechasLimiteEmpresa: '💼',
    cursosCompartidos: '🤝',
    carrerasCompartidas: '🤝',
};

// Función auxiliar para asignar colores
const getModuleColor = (id) => {
    const colors = {
        estudiantes: 'blue',
        estadisticas: 'purple',
        cursos: 'green',
        misCursos: 'sky',
        catalogoCursos: 'teal',
        catalogoCarreras: 'pink',
        misCarreras: 'rose',
        misCertificados: 'orange',
        tiendaPremios: 'rose',
        progreso: 'indigo',
        dashboardGeneral: 'violet',
        asignarCursosEstudiantes: 'emerald',
        asignarCursosArea: 'cyan',
        asignarCursosPuesto: 'indigo',
        asignarCursosTurno: 'amber',
        carreras: 'rose',
        semestres: 'blue',
        asignacionMasivaUO: 'cyan',
        asignacionMasivaEmpresa: 'indigo',
        fechasLimiteUO: 'cyan',
        fechasLimiteEmpresa: 'indigo',
        cursosCompartidos: 'amber',
        carrerasCompartidas: 'amber',
    };
    return colors[id] || 'cyan';
};

// ===================================================================
// Definición base de los submódulos de LMS
//  - El campo `id` debe coincidir con lo que guardas en Cat_Recursos.ruta
// ===================================================================
const LMS_SUBMODULES = [
    {
        id: "estudiantes",
        title: "Estudiantes",
        description: "Visualiza los estudiantes registrados en tus cursos.",
        path: "/menu/lms/estudiantes",
    },
    {
        id: "catalogoCarreras",
        title: "Catálogo de Carreras",
        description: "Explora las carreras disponibles y regístrate.",
        path: "/menu/lms/catalogo-carreras",
    },
    {
        id: "catalogoCursos",
        title: "Catálogo de cursos",
        description: "Explora todos los cursos disponibles y regístrate.",
        path: "/menu/lms/catalogo-cursos",
    },
    {
        id: "misCarreras",
        title: "Mis Carreras",
        description: "Consulta las carreras en las que estás inscrito y tu avance.",
        path: "/menu/lms/mis-carreras",
    },
    {
        id: "misCursos",
        title: "Mis cursos",
        description: "Consulta tu avance y cursos asignados.",
        path: "/menu/lms/mis-cursos",
    },
    {
        id: "misCertificados",
        title: "Mis Certificados",
        description: "Visualiza y descarga tus certificados obtenidos.",
        path: "/menu/lms/mis-certificados",
    },
    {
        id: "tiendaPremios",
        title: "Tienda de Premios",
        description: "Canjea tus monedas por premios increíbles.",
        path: "/menu/lms/tienda-premios",
    },
    {
        id: "cursos",
        title: "Administrar Cursos",
        description: "Gestiona el contenido y configuración de tus cursos.",
        path: "/menu/lms/administrar-cursos",
    },
    {
        id: "carreras",
        title: "Administrar Carreras",
        description: "Gestiona el contenido y configuración de tus carreras.",
        path: "/menu/lms/administrar-carreras",
    },
    {
        id: "progreso",
        title: "Progreso Estudiantes",
        description: "Consulta el avance detallado de tus alumnos en cada curso.",
        path: "/menu/lms/progreso",
    },
    {
        id: "estadisticas",
        title: "Estadísticas",
        description: "Revisa el rendimiento y resultados de tus estudiantes.",
        path: "/menu/lms/estadisticas",
    },
    {
        id: "dashboardGeneral",
        title: "Dashboard General",
        description: "Visualiza indicadores clave y gráficas de rendimiento.",
        path: "/menu/lms/dashboard-general",
    },
    {
        id: "asignarCursosEstudiantes",
        title: "Asignar Cursos",
        description: "Asigna fácilmente cursos a los estudiantes mediante arrastrar y soltar.",
        path: "/menu/lms/asignar-cursos-estudiantes",
    },
    {
        id: "asignarCursosArea",
        title: "Asignar por Área",
        description: "Inscripción masiva de cursos por Área de Negocio.",
        path: "/menu/lms/asignar-cursos-area",
    },
    {
        id: "asignarCursosPuesto",
        title: "Asignar por Puesto",
        description: "Inscripción masiva de cursos por Puesto de trabajo.",
        path: "/menu/lms/asignar-cursos-puesto",
    },
    {
        id: "asignarCursosTurno",
        title: "Asignar por Turno",
        description: "Inscripción masiva de cursos por Turno horario.",
        path: "/menu/lms/asignar-cursos-turno",
    },
    {
        id: "semestres",
        title: "Semestres",
        description: "Administra los periodos semestrales de las carreras.",
        path: "/menu/lms/semestres",
    },
    {
        id: "fechasLimiteUO",
        title: "Asignación Masiva U.O.",
        description: "Administra las fechas limite e inscripciones masivas para Unidades Organizacionales.",
        path: "/menu/dynamic?path=Lms/Components/Catalogos/AsignacionMasivaUnidadOrganizacional/AsignacionMasivaUnidadOrganizacionalCatalog.jsx",
    },
    {
        id: "fechasLimiteEmpresa",
        title: "Asignación Masiva Empresa",
        description: "Administra las fechas limite e inscripciones masivas por Empresa.",
        path: "/menu/dynamic?path=Lms/Components/Catalogos/AsignacionMasivaEmpresa/AsignacionMasivaEmpresaCatalog.jsx",
    },
    {
        id: "cursosCompartidos",
        title: "Cursos Compartidos",
        description: "Gestiona la distribución de cursos entre tus empresas filiales.",
        path: "/menu/lms/cursos-compartidos",
    },
    {
        id: "carrerasCompartidas",
        title: "Carreras Compartidas",
        description: "Gestiona la distribución de carreras entre tus empresas filiales.",
        path: "/menu/lms/carreras-compartidas",
    },
];

// Endpoint y modelo para recursos (SEGURIDAD.Cat_Recursos)
const endpointRecursos = ENDPOINTS.recursos; // debe apuntar a "/api/Recursos"

// Intenta usar el modelo de recursos; si cambia el nombre, ajústalo aquí.
const modeloRecurso = Models.catRecursos;

function LmsPanel() {
    const navigate = useNavigate();

    // 🔹 Usuario en sesión
    const [sessionUserId] = useState(() => getSessionUserId());

    // 🔹 Submódulos visibles según permisos
    const [visibleSubmodules, setVisibleSubmodules] = useState([]);
    const [loading, setLoading] = useState(true);
    const [errorMsg, setErrorMsg] = useState("");

    const handleClick = (path) => {
        navigate(path);
    };

    // ================================================================
    // Cargar permisos desde api/Recursos/{idUsuario}/Panel
    // y filtrar LMS_SUBMODULES por ruta
    // ================================================================
    useEffect(() => {
        async function loadRecursos() {
            try {
                if (!sessionUserId) {
                    setErrorMsg(
                        "No se pudo identificar al usuario en sesión. No hay paneles disponibles."
                    );
                    setVisibleSubmodules([]);
                    setLoading(false);
                    return;
                }

                const url = `${endpointRecursos}/${sessionUserId}/Panel`;
                const res = await axios.get(url);

                const recursos = (res.data || []).map(modeloRecurso);

                // Tomamos solo recursos:
                //  - activos
                //  - tipo === "Panel"
                //  - con una ruta no vacía
                const allowedIds = new Set(
                    recursos
                        .filter(
                            (r) =>
                                (r.tipo || "").toLowerCase() === "panel" &&
                                (r.ruta || "").trim() !== ""
                        )
                        .map((r) => (r.ruta || "").trim())
                );
                console.log("[LmsPanel] Recursos permitidos:", allowedIds);

                // Filtrar los módulos hardcodeados por esos IDs
                let filtered = LMS_SUBMODULES.filter((m) =>
                    allowedIds.has(m.id)
                );

                setVisibleSubmodules(filtered);
                setLoading(false);

                // Si no tiene nada asignado, ponemos un mensaje suave
                if (!filtered.length) {
                    setErrorMsg(
                        "No tienes paneles de LMS asignados en este momento."
                    );
                }
            } catch (err) {
                console.error("[LmsPanel] Error al cargar recursos:", err);
                setErrorMsg(
                    "Ocurrió un problema al cargar tus permisos. Intenta de nuevo más tarde."
                );
                setVisibleSubmodules([]); // por seguridad, no mostramos nada
                setLoading(false);
            }
        }

        loadRecursos();
    }, [sessionUserId]);

    return (
        <div className="modules-container">
            <h1>Sistema de Gestión de Aprendizaje (LMS)</h1>

            {loading ? (
                <div className="modules-loading">Cargando paneles disponibles...</div>
            ) : errorMsg ? (
                <div className="modules-error">{errorMsg}</div>
            ) : (
                <>
                    <div className="modules-grid">
                        {visibleSubmodules.map((submodule) => (
                            <div
                                key={submodule.id}
                                className={`module-card module-card--${getModuleColor(submodule.id)}`}
                                onClick={() => handleClick(submodule.path)}
                                role="button"
                                tabIndex={0}
                                onKeyPress={(e) => e.key === 'Enter' && handleClick(submodule.path)}
                            >
                                <div className="module-card__title">{submodule.title}</div>
                                <div className="module-card__description">{submodule.description}</div>
                                <div className="module-card__icon" aria-hidden="true">
                                    {submoduleIcons[submodule.id] || '📁'}
                                </div>
                            </div>
                        ))}
                    </div>
                </>
            )}

            {/* Si no hay módulos visibles y no está cargando, mostramos mensaje */}
            {!loading && !visibleSubmodules.length && !errorMsg && (
                <div className="modules-empty">No hay paneles de LMS disponibles.</div>
            )}
        </div>
    );
}

export default LmsPanel;
